import { LoaderScreen } from '@/components/Elements';
import { Layout } from '@/features/auth/components/Layout';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { useUser } from '@/lib/auth';
import { PRIVATE_TOP_PATH } from '@/routes/private';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = useUser();

  useEffect(() => {
    if (user.data == null) return;

    const redirectUrl = searchParams.get('to');
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate(PRIVATE_TOP_PATH);
    }
  }, [navigate, user.data, searchParams]);

  if (user.isLoading) {
    return (
      <Layout>
        <LoaderScreen />
      </Layout>
    );
  }

  return (
    <Layout>
      <LoginForm />
    </Layout>
  );
};
